'use client';

/**
 * Mounts the exam screen for one paper on the public route.
 *
 * previewQuestions is the whole point: a signed-out visitor answers the first five questions and
 * then meets the wall. Signed-in users pass straight through, and /dev/paper does not use this
 * component at all, so nothing internal is gated.
 *
 * Back goes to the paper list rather than through browser history, because a child arriving from
 * a search result has no history to go back through.
 */

import { useRouter } from 'next/navigation';
import PaperExam from '@/components/kangaroo-math/PaperExam';
import { FREE_PREVIEW_QUESTIONS } from '@/lib/olympiad-papers';

export default function SitPaper({ paper }: { paper: string }) {
  const router = useRouter();
  return (
    <PaperExam
      paper={paper}
      previewQuestions={FREE_PREVIEW_QUESTIONS}
      onBack={() => router.push('/math-olympiad-prep/papers')}
    />
  );
}
